// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import AppSignUpPage from '../../components/SignUp/SignUpPages/AppSignUpPage';

const SignUp: React.FC = () => {
    return (
        <Entrypoint>
            <AppSignUpPage />
        </Entrypoint>
    );
}

export default SignUp;